import React from "react";

function MissionSection() {
  return (
    <section className="mission">
      <div className="mission-inner">
        <h2>Our Mission</h2>
        <p>
          CofounderHubs exists to bridge the gap between ambitious founders and their ideal partners.
          We believe every great startup begins with the right team. Our platform connects aspiring
          entrepreneurs across the globe — making it effortless to discover, evaluate, and reach out
          to potential co-founders through trusted networks like LinkedIn and Y Combinator.
        </p>
        <p>
          Whether you're a technical builder looking for a business mind, or a visionary seeking an
          execution partner, CofounderHubs is where your startup journey begins.
        </p>
      </div>
    </section>
  );
}

export default MissionSection;
